
var $animatedE = false;


jQuery.fn.isInViewport = function() {

  var offset = 0;
  var $el = jQuery(this);
  if($el.attr('data-offset'))offset = 1 * $el.attr('data-offset');
  if(offset > 0 && offset < 1)offset = offset * $el.height();

  var elementTop = $el.offset().top - offset;
  var elementBottom = elementTop + $el.outerHeight() + offset;
  var viewportTop = jQuery(window).scrollTop();
  var viewportBottom = viewportTop + jQuery(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function checkAnimation() {
  if(!$animatedE) return ;
  $animatedE.each(function() {
    var $el = jQuery(this);
    if(!$el.hasClass('in') && $el.isInViewport()) {
      if($el.hasClass('mp-staggered')) {
        $el.css('transition-delay', (150 * $el.index()) + 'ms')
      }
      $el.addClass('in');

      if($el.hasClass('b-lazy')) {
        bLazy.load($el);
      }
      else if($el.find('.b-lazy').length > 0)bLazy.load($el.find('.b-lazy'));
    }
  })
}

jQuery(function($) {

  $(document).ready(function() {

    $animatedE = $('.mp-animated');
    checkAnimation();
    $(document).scroll(function() {
      checkAnimation();
    });

  })

})
